import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Page from '../../../components/Page';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Menu from './Menu';
import MobileMenu from './MobileMenu';
import { withController } from './Controller';
import { useSelector } from 'react-redux';
import PlatformEmail from './PlatformEmail';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles({
  menu: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '4rem 0 1rem 0',
  },
  container: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0 2rem 2rem 2rem',
  },
  row: {
    width: '100%',
    display: 'flex',
    flexWrap: 'no-wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5rem 1rem 0.5rem 0',
  },
  title: {
    padding: 0,
    width: '100%',
    marginBottom: '1rem',
  },
  content: {
    width: '100%',
    padding: '1rem 0',
    minHeight: '20rem',
  },
});

const AccountPage = ({title=null, service, showPlatformEmail=false, children}) => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const theme = useTheme();
  const {profile, isAuthenticated} = useSelector(state => state.auth);
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  const renderContent = (classes, children) => {
    return (
      <Fragment>
        <div className={classes.row}>
          <Typography
            variant="h6"
            color="primary"
            className={classes.title}
          >
            {title === null ? service.name : title}
          </Typography>
          {showPlatformEmail ? (<PlatformEmail />) : null}
        </div>
        <Box className={classes.content}>
          {children}
        </Box>
      </Fragment>
    );
  };

  // this block redirects to login and back here again if user is not logged in.
  if (!isAuthenticated) {
    history.replace('/login', {redirectTo: location.pathname + location.search});
    return null;
  }

  if (profile.is_provider) {
    history.replace('/providers/profile');
    return null;
  }

  return (
    <Page title="Clickability - Participant Account">
      <Container maxWidth="lg" fixed disableGutters={true}>
        <Grid container spacing={0}>
          {mobile ? (
            <Grid item sm={12} className={classes.container}>
              <MobileMenu service={service} />
              {renderContent(classes, children)}
            </Grid>
          ) : (
            <Fragment>
              <Grid item md={2} className={classes.menu}>
                <Menu service={service} />
              </Grid>
              <Grid item md={10} className={classes.container}>
                {renderContent(classes, children)}
              </Grid>
            </Fragment>
          )}
        </Grid>
      </Container>
    </Page>
  );
};

AccountPage.propTypes = {
  title: PropTypes.string,
  service: PropTypes.object.isRequired,
  showPlatformEmail: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
};

export default withController(AccountPage);
